import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Input2, DropDown2, EventsDropDown, DateRange, Button, CheckBox } from "components";
import { FaHourglass, FaTrash } from "react-icons/fa";
import { useInput, useModal } from "hooks";
import { CreateAdblockIncentive, CreateAdblockOffer } from "modals";
import { useMainContext } from "contexts";
import { ROPRetailers, AdTypes, ColorTypes, Languages, ROPSizeTypes } from "utils";

export const GroupItem = ({
  isLoading,
  data,
  index,
  onDelete,
  active = false,
  type = "group",
  onClick = () => { },
  onChangeText = () => { },
  onChangeSelect = () => { },
  isDeleting = false
}) => {
  const { activeRetailer } = useMainContext();
  // ROP retailers get the extra group fields flat/always-visible (required, empty by default).
  // Only applies to Newspaper circulars (circ_type "Newspaper" / PAGE_TYPES page_c "R").
  const isROP = ROPRetailers.includes(activeRetailer?.retailer_name)
    && ["Newspaper (ROP)", "Newspaper"].includes(activeRetailer?.circ_type);
  // Group Data
  const [typeGroup, setTypeGroup] = useState([
    { title: 'offer', id: 'offer' },
    { title: 'incentive', id: 'incentive' },
    { title: 'event', id: 'event' },
    { title: 'limited time', id: 'limitedtime' }
  ])
  // Flags for Group Types
  // Using flags for this instead of lists or object to minimize code complexity
  // An array could be used to reduce the number of lines and caring about the indexes
  // But as we are using one group type per group I believe we can skip it for now.
  const [offerType, setOfferType] = useState(false);
  const [incentiveType, setIncentiveType] = useState(false);
  const [eventType, setEventType] = useState(false);
  const [limitedTime, setLimitedTime] = useState(false);

  // Inputs for Group Texts
  const events = useInput([]);
  const [offerText, setOfferText] = useState("");
  const [incentiveText, setIncentiveText] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [showGroupDropDown, setShowGroupDropDown] = useState(true);

  // Flags
  const [hideAddGroup, setHideAddGroup] = useState(false);
  const [loyalty, setLoyalty] = useState(false);
  const [showMath, setShowMath] = useState(false);
  const [onlineOnly, setOnlineOnly] = useState(false);
  const [sponsored, setSponsored] = useState(false);

  // ROP Fiels
  const [fullyEntered, setFullyEntered] = useState(null);
  const [coupon, setCoupon] = useState(null);
  const [colorType, setColorType] = useState(null);
  const [language, setLanguage] = useState(null);
  const [size, setSize] = useState(null);
  const [adType, setAdType] = useState(null);

  // Model
  const adblockIncentiveModal = useModal();
  const adblockOfferModal = useModal();

  useEffect(() => {
    console.log('DATA:', data)
    if (data?.offer_type
      || data?.event_type
      || data?.incentive_type
      || data?.event_type
      || data?.limited_time 
      || data?.loyalty_f
      || data.show_math_f
      || data.online_only_f
      || data?.fully_entered_f
      || data?.coupon_f
      || typeof data?.color_f === 'boolean'
      || data?.size_type
      || data?.language
      || data?.ad_type) {
      let removeFromTypeGroup = [];
      if (data?.offer_type) {
        setOfferType(true);
        setOfferText(data?.offer_text);
        removeFromTypeGroup.push('offer')
      }
      if (data?.event_type) {
        if (typeof data?.event_text === 'string') {
          let ev = data?.event_text.split(',');
          setEventType(true);
          events.setValue(ev);
        }
        removeFromTypeGroup.push('event')
      }
      if (data?.limited_time) {
        setLimitedTime(true);
        setStartDate(data?.start || '');
        setEndDate(data?.end || '');
        removeFromTypeGroup.push('limitedtime')
      }
      if (data?.incentive_type) {
        setIncentiveType(true);
        setIncentiveText(data?.incentive_text);
        removeFromTypeGroup.push('incentive')
      }
      if (data?.loyalty_f) {
        setLoyalty(true)
      }
      if (data?.show_math_f) {
        setShowMath(true)
      }
      if(data?.online_only_f){
        setOnlineOnly(true)
      }
      if(data?.sponsored_f){
        setSponsored(true)
      }
      if(data?.fully_entered_f){
        setFullyEntered(true)
      }
      if(data?.coupon_f){
        setCoupon(true)
      }
      if(data?.color_f !== null && data?.color_f !== undefined){
        setColorType(data?.color_f === true ? 'Color' : 'B+W')
        removeFromTypeGroup.push('colorType')
      }
      if(data?.size_type){
        setSize(data?.size_type);
        removeFromTypeGroup.push('size')
      }
      if(data?.language){
        setLanguage(data?.language);
        removeFromTypeGroup.push('language')
      }
      if(data?.ad_type){
        setAdType(data?.ad_type);
        removeFromTypeGroup.push('adType')
       }
      let group_types = typeGroup.filter(item => !removeFromTypeGroup.includes(item.id));
      setTypeGroup(group_types);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])


  /**
   * Group Text and Group Type is deprecated now!
   * The Below Code is for the same.
   */

  // useEffect(() => {
  //   if (data?.group_type === 'event' && data?.group_text) {
  //     if (typeof data?.group_text === 'string') {
  //       events.setValue(data?.group_text?.split(","));
  //       onChangeText('');
  //     }
  //   }
  //   handleLimitedTimeSelection();
  //   return () => { }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  // useEffect(() => {

  //   console.log('groupt_type', data?.group_type);
  //   if (data) {

  //     if (data?.group_type) {
  //       setGroupType(data?.group_type);
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [data]);

  // useEffect(() => {
  //   handleLimitedTimeSelection();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [groupType])

  // const onChangeSelect = (type, item) => {
  //   setGroupType(type);
  // };

  const handleDelete = (data, index) => {
    onDelete(data, index);
  };

  const handleAdblockIncentiveModal = () => {
    console.log('modal', adblockIncentiveModal.open);
    adblockIncentiveModal.openModal();
  }
  
  const handleAdblockOfferModal = () => {
    adblockOfferModal.openModal();
  }

  const handleAddGroupItem = () => {
    setShowGroupDropDown(true);
  }

  // const handleLimitedTimeSelection = () => {
  //   if (data?.group_type === 'limitedtime' && data?.group_text) {
  //     if (typeof data?.group_text === 'string') {
  //       const text = data?.group_text.split('to');
  //       setStartDate(text[0]);
  //       setEndDate(text[1]);
  //       onChangeText(`${text[0]}to${text[1]}`);
  //     }
  //   } else if (data?.group_type === 'limitedtime' && startDate && endDate) {
  //     onChangeText(`${startDate}to${endDate}`);
  //   }
  // }

  const handleDropDownSelection = (e) => {
    setHideAddGroup(true);
    setShowGroupDropDown(false);
    setTypeGroup(typeGroup.filter(item => item.id !== e))
    if (e === 'offer') {
      setOfferType(true);
    }
    else if (e === 'event') {
      setEventType(true);
    }
    else if (e === 'incentive') {
      setIncentiveType(true);
    }
    else if (e === 'limitedtime') {
      setLimitedTime(true);
      setHideAddGroup(false);
      handleChangeText({ limitedTimeOverride: true });
    }
    else if (e === 'colorType') {
      setColorType(true);
      setHideAddGroup(false);
    }
    else if (e === 'language') {
      setLanguage(true);
      setHideAddGroup(false);
    }
    else if (e === 'size') {
      setSize(true);
      setHideAddGroup(false);
    }
    else if (e === 'adType') {
      setAdType(true);
      setHideAddGroup(false);
    }
  }

  const handleDeleteGroupItem = (item) => {
    let g = {}
    if (item === 'offer') {
      setOfferType(false);
      setOfferText('');
      handleChangeText({ offer_type: false, offer_text: '' });
      g = { title: 'offer', id: 'offer' };
    }
    else if (item === 'event') {
      setEventType(false);
      events.setValue([]);
      handleChangeText({ event_type: false, event_text: [] });
      g = { title: 'event', id: 'event' }
    }
    else if (item === 'incentive') {
      setIncentiveType(false);
      setIncentiveText('');
      handleChangeText({ incentive_type: false, incentive_text: '' });
      g = { title: 'incentive', id: 'incentive' }
    }
    else if (item === 'limitedtime') {
      setLimitedTime(false);
      setStartDate('');
      setEndDate('');
      handleChangeText({ limited_time: false, start: undefined, end: undefined });
      g = { title: 'limited time', id: 'limitedtime' }
    }
    else if (item === 'colorType') {
      setColorType(false);
      handleChangeText({ color_f: null });
      g = { title: 'Color Type', id: 'colorType' }
    }
    else if (item === 'language') {
      setLanguage(false);
      handleChangeText({ language: null });
      g = { title: 'Language', id: 'language' }
    }
    else if (item === 'size') {
      setSize(false);
      handleChangeText({ size_type: null });
      g = { title: 'Size', id: 'size' }
    }
    else if (item === 'adType') {
      setAdType(false);
      handleChangeText({ ad_type: null });
      g = { title: 'Ad Type', id: 'adType' }
    }
    setTypeGroup([...typeGroup, g]);
    setHideAddGroup(false);
  }

  const handleChangeText = (overrides = {}) => {
    const group_data = {
      offer_type: offerType,
      offer_text: offerText,
      event_type: eventType,
      event_text: events.value,
      incentive_type: incentiveType,
      incentive_text: incentiveText,
      limited_time: overrides.limitedTimeOverride ?? limitedTime,
      start: startDate || undefined,
      end: endDate || undefined,
      loyalty_f: loyalty,
      show_math_f: showMath,
      online_only_f: onlineOnly,
      sponsored_f: sponsored,
      fully_entered_f: fullyEntered,
      coupon_f: coupon,
      color_f: colorType,
      size_type: size,
      language: language,
      ad_type: adType,
      ...overrides
    };

    if(group_data.color_f === 'Color')
      group_data.color_f = true;
    else if(group_data.color_f === 'B+W')
      group_data.color_f = false;

    onChangeText(group_data);
  }

  const handleEventChange = (e) => {
    if (e) {
      setHideAddGroup(false);
    } else {
      setHideAddGroup(true);
    }
    events.setValue(e);
    handleChangeText({ event_text: e })
  }

  return (
    <Container type={active ? "active" : type} onClick={onClick}>
      <div className="inner">
        <SectionTitle>Group {data?.index}</SectionTitle>
        <SectionUUID className="mt-1">{data?.uuid}</SectionUUID>

        <div className="group-container" >
          {offerType &&
            <GroupItems
              groupType='offer'
              onDelete={handleDeleteGroupItem}
            >
              <span className="select-label my-auto text-light">Offer</span>
              <TextBuilderButton
                  isSelected={adblockOfferModal.open}
                  onClick={handleAdblockOfferModal}
                >
                  Open Offer Text Builder
                </TextBuilderButton>
              <Input2
                value={offerText}
                placeholder="Enter the offer text"
                onChange={(e) => {
                  if (e) {
                    setHideAddGroup(false);
                  } else {
                    setHideAddGroup(true);
                  }
                  setOfferText(e);
                  handleChangeText({ offer_text: e });
                }}
              />
            </GroupItems>
          }
          {eventType &&
            <GroupItems
              groupType='event'
              onDelete={handleDeleteGroupItem}
            >
              <EventsDropDown
                textColor="text-light"
                pageId={data.uuid}
                {...events}
                onChange={(e) => handleEventChange(e)}
                applyToPage={false}
              />
            </GroupItems>
          }
            {incentiveType &&
              <GroupItems
              groupType='incentive'
              onDelete={handleDeleteGroupItem}
              >
                <span className="select-label my-auto text-light">Incentives</span>
                <TextBuilderButton
                  isSelected={adblockIncentiveModal.open}
                  onClick={handleAdblockIncentiveModal}
                >
                  Open Incentive Builder
                </TextBuilderButton>
                <Input2
                  value={incentiveText}
                  placeholder="Incentive Text"
                  className="mt-2"
                  onChange={(e) => {
                    if (e) {
                      setHideAddGroup(false);
                    } else {
                      setHideAddGroup(true);
                    }
                    setIncentiveText(e);
                    handleChangeText({ incentive_text: e });
                  }}
                  />
              </GroupItems>
            }

          {limitedTime &&
            <GroupItems 
              groupType='limitedtime'
              onDelete={handleDeleteGroupItem}
            >
              <span className="select-label my-auto text-light">Limited Time</span>
              <DateRange
                open={true}
                className="mt-2 mb-2"
                width="w-50"
                startDate={startDate}
                endDate={endDate}
                onChange={(dates) => {
                  setStartDate(dates[0]);
                  setEndDate(dates[1]);
                  if (dates[0] && dates[1]){
                    setHideAddGroup(false);
                  } else {
                    setHideAddGroup(true);
                  }
                  handleChangeText({ start: dates[0], end: dates[1] });
                }}
              />
            </GroupItems>
          }
          {(isROP || adType) &&
            <GroupItems
              groupType='adType'
              onDelete={handleDeleteGroupItem}
              hideDelete={isROP}
            >
              <span className="select-label my-auto text-light">Ad Type</span>
              <DropDown2
                data={AdTypes}
                value={adType}
                onChange={(e) => {
                  setAdType(e);
                  handleChangeText({ ad_type: e })
                }}
                className="group-item"
              ></DropDown2>
            </GroupItems>
          }
          {(isROP || colorType) &&
            <GroupItems
              groupType='colorType'
              onDelete={handleDeleteGroupItem}
              hideDelete={isROP}
            >
              <span className="select-label my-auto text-light">Color Type</span>
              <DropDown2
                data={ColorTypes}
                value={colorType}
                onChange={(e) => {
                  setColorType(e);
                  handleChangeText({ color_f: e })
                }}
                className="group-item"
              ></DropDown2>
            </GroupItems>
          }
          {(isROP || language) &&
            <GroupItems
              groupType='language'
              onDelete={handleDeleteGroupItem}
              hideDelete={isROP}
            >
              <span className="select-label my-auto text-light">Language</span>
              <DropDown2
                data={Languages}
                value={language}
                onChange={(e) => {
                  setLanguage(e);
                  handleChangeText({ language: e })
                }}
                className="group-item"
              ></DropDown2>
            </GroupItems>
          }
          {(isROP || size) &&
            <GroupItems
              groupType='size'
              onDelete={handleDeleteGroupItem}
              hideDelete={isROP}
            >
              <span className="select-label my-auto text-light">Size</span>
              <DropDown2
                data={ROPSizeTypes}
                value={size}
                onChange={(e) => {
                  setSize(e);
                  handleChangeText({ size_type: e })
                }}
                className="group-item"
              ></DropDown2>
            </GroupItems>
          }
        </div>
        <div className="">
          {(showGroupDropDown && typeGroup.length > 0) &&
            <DropDown2
              data={typeGroup}
              onChange={(e) => handleDropDownSelection(e)}
              className="group-item"
            ></DropDown2>
          }

          <CheckBox
            value={loyalty}
            onChange={(e) => {
              setLoyalty(e);
              handleChangeText({ loyalty_f: e });
            }}
            
          >Loyalty</CheckBox>

          <CheckBox
            value={showMath}
            onChange={(e) => {
              setShowMath(e);
              handleChangeText({ show_math_f: e });
            }}
          >Show Math</CheckBox>
          
          <CheckBox
            value={onlineOnly}
            onChange={(e) => {
              setOnlineOnly(e);
              handleChangeText({ online_only_f: e });
            }}
          >Online Only</CheckBox>

          <CheckBox
            value={sponsored}
            onChange={(e) => {
              setSponsored(e);
              handleChangeText({ sponsored_f: e });
            }}
          >Sponsored</CheckBox>

          {isROP &&
            <>
              <CheckBox
                value={fullyEntered}
                onChange={(e) => {
                  setFullyEntered(e);
                  handleChangeText({ fully_entered_f: e });
                }}
              >Fully Entered</CheckBox>
              <CheckBox
                value={coupon}
                onChange={(e) => {
                  setCoupon(e);
                  handleChangeText({ coupon_f: e });
                }}
              >Coupon</CheckBox>
            </>
          }

          <AddButton
            size="small"
            onClick={handleAddGroupItem}
            disabled={hideAddGroup || !typeGroup.length > 0}
          >
            ADD
          </AddButton>
        </div>
      

        {!isDeleting ?
          <FaTrash
            className="deleteIcon"
            onClick={() => handleDelete(data, index)}
          /> :
          <FaHourglass
            className="deleteIcon"
          />
        }
      <CreateAdblockIncentive
        {...adblockIncentiveModal}
        incentiveText={incentiveText}
        onSubmit={e => {
          handleChangeText({ incentive_text: e });
          setHideAddGroup(false);
        }}
      />
      <CreateAdblockOffer
        {...adblockOfferModal}
        offerData={offerText}
        onSubmit={e => {
          handleChangeText({ offer_text: e })
          setHideAddGroup(false);
        }}
      />
      </div>
    </Container>
  );
};

const GroupItems = ({
  children,
  groupType,
  onDelete = () => { },
  hideDelete = false
}) => {
  return <div className="group">
    <div className="group-item" style={hideDelete ? { width: "100%" } : undefined}>
      {children}
    </div>
    {!hideDelete &&
      <div
        className="group-remove text-center cursor-pointer"
        onClick={() => onDelete(groupType)}
      >
        X
      </div>
    }
  </div>
}


const Container = styled.div`
    position: relative;
    cursor: pointer;
    background: ${(props) => props.theme.palette.items};
    display: block;
    color: white;
    font-size: 12px;
    transition: all 300ms ease;
    font-size: ${(props) => props.theme.palette.m};
    border: 1px solid
    ${(props) =>
    props.type === "active"
      ? props.theme.palette.primary
      : props.type === "page"
        ? props.theme.palette.accentHover
        : props.type === "circular"
          ? props.theme.palette.accentHover
          : props.type === "rejected"
            ? props.theme.palette.error
            : props.theme.palette.gray};
    border-left: 12px solid
    ${(props) =>
    props.type === "active"
      ? props.theme.palette.primary
      : props.type === "page"
        ? props.theme.palette.accentHover
        : props.type === "circular"
          ? props.theme.palette.accentHover
          : props.type === "rejected"
            ? props.theme.palette.error
            : props.theme.palette.gray};

    margin: 3px 6px 3px 6px;
    border-radius: 2px;
    input {

    font-size:12px !important;
  }
  .inner {
    width: 100%;
    padding: 5px;
    /* height: 45px; */
    &:hover {
      background: ${(props) =>
        props.isLoading
          ? props.theme.palette.items
          : props.theme.palette.itemsHover};
    }

    .deleteIcon {
      position: absolute;
      right: 10px;
      top: 5px;

      &:hover {
        background: ${(props) =>
          props.isLoading
            ? props.theme.palette.items
            : props.theme.palette.itemsHover};
            }
        }

    .group-container{}

    .group{
      display: flex;
      justify-content: space-around;
    }

    .group-item {
      width: 85%;
      padding: 5px;
    }

    .group-remove {
      width: 15%;
      padding: 5px;
      margin-top: 10px;
      font-weight: bolder;
      height: fit-content;
      border-radius: 20%;
      transition: all 0.1s ease-in-out;

    &:hover {
      background: #2B2B2B;
      }
    }

  }
    `;

const SectionTitle = styled.div`
    font-size: 14px;
    `;

const SectionUUID = styled.div`
    font-size: 10px;
    color: ${(props) => props.theme.palette.secondary};
    `;

const TextBuilderButton = styled.p`
    text-decoration: underline;
    font-size: 10px;
    box-sizing: border-box;
    text-align: right;
    /* z-index: 2; */
    /* position: absolute; */
    margin: 0;
    right: 5px;
    margin-top: 8px;
    transition: opacity 300ms ease-out;
    `

const AddButton = styled(Button)`
    width: 50px;
    max-width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-top: 5px;
    margin-bottom: 5px;
    left: 80%;
    background-color: #2B2B2B;
    border: 1px solid #2B2B2B;

    &:hover {
      background-color: #555454;
  }
    `
